import { render, staticRenderFns } from "./Voir_livraisons.vue?vue&type=template&id=515b0bb7&"
import script from "./Voir_livraisons.vue?vue&type=script&lang=js&"
export * from "./Voir_livraisons.vue?vue&type=script&lang=js&"
import style0 from "./Voir_livraisons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports